let df = null
let keysForWatch = []

class Dep {
  constructor () {
    this.subscribers = new Set()
  }

  depend (key) {
    if (keysForWatch && keysForWatch.length && !keysForWatch.includes(key)) {
      return
    }
    df && this.subscribers.add(df)
  }

  notify () {
    this.subscribers.forEach(sub => { setTimeout(sub, 0) })
  }
}

const depsStorage = new WeakMap()
const handlers = {
  get (obj, key) {
    let deps = depsStorage.get(obj)
    if (!deps) {
      deps = {}
      depsStorage.set(obj, deps)
    }
    if (!deps[key]) {
      deps[key] = new Dep()
    }
    deps[key].depend && deps[key].depend(key)
    return observable(obj[key])
  },
  set (obj, key, value) {
    obj[key] = value
    const deps = depsStorage.get(obj)
    if (deps && deps[key]) {
      deps[key].notify()
    }
    return true
  }
}

const observedValues = new WeakMap()
function observable (obj) {
  if (!obj || typeof obj !== 'object') {
    return obj
  }
  if (observedValues.has(obj)) {
    return observedValues.get(obj)
  }
  const observed = new Proxy(obj, handlers)
  observedValues.set(obj, observed)
  return observed
}

function watcher (fun, keys) {
  df = fun
  keysForWatch = keys
  fun()
  df = null
  keysForWatch = []
}

export const reactive = {
  create: observable,
  watch: watcher
}
